// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___PxkL6","header":"styles__header___2JnHw","body":"styles__body___2xRCO","item":"styles__item___18Ozh","subMenuWrapper":"styles__subMenuWrapper___1_c3Y"};